<template>
    <div class="vx-card px-6 py-2">
        <vs-table class="table-custom mt-6" :data="consultingData" noDataText="Không có dữ liệu" stripe>
            <template slot="thead">
                <vs-th>
                    STT
                </vs-th>
                <vs-th>
                    <div style="width: 200px">
                        <label>Thời gian</label>
                        <date-range-picker ref="picker" :locale-data="{ format: 'dd/mm/yyyy' }" :opens="'right'"
                            @update="dateRangePicker" v-model="dateRange" class="w-full" style="width: 200px">
                        </date-range-picker>
                    </div>
                </vs-th>
                <vs-th>
                    <div style="width: 200px;">
                        <label>Phân loại khách hàng</label>
                        <v-select v-model="customerType" :options="customerTypeOptions" :reduce="item => item.value" :clearable="false" style="width: 200px;" @input="filter"></v-select>
                    </div>
                </vs-th>
                <vs-th>
                    <div class="w-full">
                        <label>Mảng dịch vụ</label>
                        <vs-input v-model="beautyGroupServiceName" @keyup.enter="filter"/>
                    </div>
                </vs-th>
                <vs-th>
                    <div class="w-full">
                        <label>Nhóm dịch vụ</label>
                        <vs-input v-model="beautyServicePackageName" @keyup.enter="filter"/>
                    </div>
                </vs-th>
                <vs-th>
                    <div class="w-full">
                        <label>Bác sĩ</label>
                        <vs-input />
                    </div>
                </vs-th>
                <vs-th>
                    <div class="w-full">
                        <label>Lí do</label>
                        <vs-input v-model="reason" @keyup.enter="filter"/>
                    </div>
                </vs-th>
                <vs-th>
                    <div class="w-full">
                        <label>Kết luận</label>
                        <vs-input v-model="conclude" @keyup.enter="filter"/>
                    </div>
                </vs-th>
                <vs-th>
                    <div class="w-full">
                        <label>Trạng thái hồ sơ</label>
                        <v-select v-model="selectedStatusValue" :options="statusOptions" name="status"
                            :clearable="false" :reduce="item => item.value" style="width: 200px" @input="filter">
                            <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                        </v-select>
                    </div>
                </vs-th>
                <vs-th>
                    <div style="width: 200px">
                        <label>Ngày lưu</label>
                        <date-range-picker ref="picker" :locale-data="{ format: 'dd/mm/yyyy' }" :opens="'left'"
                            @update="dateRangePicker" v-model="dateRange" class="w-full" style="width: 200px">
                        </date-range-picker>
                    </div>
                </vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        {{ tr.stt }}
                    </vs-td>

                    <vs-td>
                        {{ tr.dateAdmissionStr }}
                    </vs-td>
                    <vs-td>
                        <vs-chip  class="ag-grid-cell-chip" :color="chipColor(tr.customerType)">
                            <span>{{ checkCustomerType(tr.customerType) }}</span>
                        </vs-chip>
                    </vs-td>

                    <vs-td>
                        {{ tr.beautyMedicalReports.length > 0 && tr.beautyMedicalReports[0].beautyGroupService ?
                            tr.beautyMedicalReports[0].beautyGroupService.name : null }}
                    </vs-td>

                    <vs-td class="">
                        {{ tr.beautyMedicalReports.length > 0 &&
                            tr.beautyMedicalReports[0].beautyMedicalReportDetails.length > 0 &&
                            tr.beautyMedicalReports[0].beautyMedicalReportDetails[0].beautyService ?
                            tr.beautyMedicalReports[0].beautyMedicalReportDetails[0].beautyService.name : null }}
                    </vs-td>

                    <vs-td>
                        {{ tr.doctor }}
                    </vs-td>
                    <vs-td>
                        {{ tr.beautyMedicalReports[0].reason }}
                    </vs-td>
                    <vs-td>
                        {{ tr.conclude }}
                    </vs-td>
                    <vs-td>
                        {{ tr.nanoStatus }}
                    </vs-td>
                    <vs-td>
                        {{ tr.createdDateCvt }}
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>

        <div class="vx-row" v-if="consultingData.length > 0">
            <div class="vx-col md:w-1/2">
                <div class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4 vx-row">
                    <span class="vx-col mt-2">Số phần tử / trang:</span>
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                        <div
                            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                            <span class="mr-2">
                                {{
                                    consultingData.length - currentPage * pageSize > 0 ? currentPage *
                                        pageSize
                                        : consultingData.length
                                }} /
                                {{ totalElements }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="changePageSize(20)">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(30)">
                                <span>30</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(50)">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(100)">
                                <span>100</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
                <vs-pagination :total="totalPages" v-model="currentPage" @change="loadPage" />
            </div>
        </div>
    </div>
</template>

<script>

import vSelect from 'vue-select';
import DateRangePicker from '../../../../../../components/vue2-daterange-picker/components/DateRangePicker.vue';
import { AgGridVue } from "ag-grid-vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import CellRendererStatus from "./cell-renderer/CellRendererStatus";
import CellRendererActionsConsulting from "./cell-renderer/CellRendererActionsConsulting";
import CellRendererCustomerStatus from "./cell-renderer/CellRendererCustomerStatus";
import moment from "moment";
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { ModuleRegistry } from '@ag-grid-community/core';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { Vietnamese } from 'flatpickr/dist/l10n/vn';

ModuleRegistry.registerModules([ClientSideRowModelModule]);

export default {
    components: {
        vSelect,
        DateRangePicker,
        flatPickr,
        AgGridVue,
        CellRendererStatus,
        CellRendererActionsConsulting,
        CellRendererCustomerStatus,
    },

    props: {
        loyaltyCustomerId: {
            default: null,
            type: Number,
        },
    },

    data() {
        return {
            configDatePicker: {
                dateFormat: 'Z',
                locale: Vietnamese,
                altFormat: 'd/m/Y',
                altInput: true,
                allowInput: true,
            },
            dateRange: {
                startDate: null,
                endDate: null,
            },
            parentId: null,
            // AgGrid
            gridApi: null,
            gridOptions: {},
            pageNumber: 0,
            pageSize: 20,
            totalPages: 0,
            currentPage: 1,
            totalElements: 0,
            consultingData: [],
            customerOptions: [],
            selectedCustomerValue: 'null',
            pageNumberSelectCustomer: 0,
            pageSizeSelectCustomer: 20,
            statusOptions: [],
            customerType:null,
            beautyGroupServiceName:null,
            beautyServicePackageName:null,
            reason:null,
            conclude:null,
            selectedStatusValue: 'null',
            customerTypeOptions:[
                {value:null,label:"Tất cả"},
                {value:1,label:'Khách hàng cũ tới khám (thay băng cắt chỉ)'},
                {value:2,label:'Khách hàng cũ tới sử dụng dịch vụ gói'},
                {value:3,label:'Khách hàng cũ tới tư vấn dv'},
                {value:4,label:'Khách hàng mới đến tư vấn'},
                {value:5,label:'Khách hàng tới mua thuốc mỹ phẩm'},
                {value:6,label:'Khách hàng trả lại thuốc'},
                {value:7,label:'Khách hàng tới hoàn phí (hoàn cọc)'},
                {value:8,label:'Khách hàng tới bảo hành'},

            ],
        }
    },

    async created() {

        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.map(x => {
            return { label: x.organizationBranchName, value: x.id }
        });
        this.branchOptions.unshift({ value: null, label: 'Tất cả' });

        await this.getParentId();
        this.getConsultingData();
    },
    computed: {
        chipColor() {
            return value => {
                if (value === 1) {
                    return "warning"
                } else if (value === 2) {
                    return "complete"
                } else if (value === 3) {
                    return "danger"
                } else if (value === 4) {
                    return "primary"
                } else if (value === 5) {
                    return "warning"
                } else if (value === 6) {
                    return "complete"
                } else if (value === 7) {
                    return "danger"
                }
            }
        },
        checkCustomerType() {
            return value => {
                if (value === 1) {
                    return "Khách hàng cũ tới khám (thay băng cắt chỉ)";
                } else if (value === 2) {
                    return "Khách hàng cũ tới sử dụng dịch vụ gói"
                } else if (value === 3) {
                    return "Khách hàng cũ tới tư vấn dv"
                } else if (value === 4) {
                    return "Khách hàng mới đến tư vấn"
                } else if (value === 5) {
                    return "Khách hàng tới mua thuốc mỹ phẩm"
                } else if (value === 6) {
                    return "Khách hàng trả lại thuốc"
                } else if (value === 7) {
                    return "Khách hàng tới hoàn phí (hoàn cọc)"
                } else if (value === 8) {
                    return "Khách hàng tới bảo hành"
                }
            }
        },
    },

    watch: {
        '$store.state.windowWidth'(val) {
            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.deleteBeautyBooking'(val) {
            if (val) {
                this.getConsultingData();
                this.$store.commit('DELETE_BEAUTY_BOOKING', false);
            }
        },
        '$store.state.isUpdateFile'(val) {
            if (val) {
                this.filter();
                this.$store.commit('UPDATE_FILE_SUCCESS', false);
            }
        },
        dateRange(newDateRange) {
            this.getConsultingData(); 
        }
    },

    methods: {
      
        filter() {
            this.pageNumber = 0;
            this.currentPage = 1;
            this.getConsultingData();
        },

        getLabelString(object) {
            return (object && object.label) || 'Chưa xác định';
        },
        dateRangePicker: function () {
            this.dateRange.startDate = new Date(this.dateRange.startDate.setHours(0, 0, 0, 0));
            this.dateRange.endDate = new Date(this.dateRange.endDate.setHours(23, 59, 59, 999));
        },

        onGridReady() {
            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },

        loadPage: function (currentPage) {
            if (this.pageNumber !== parseInt(currentPage) - 1) {
                this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.getConsultingData();
            }
        },

        changePageSize(number) {
            this.pageSize = number;
            this.pageNumber = 0;
            this.currentPage = 1;
            this.getConsultingData();
        },

        getParentId() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();

                this.$crm.post('/setting-medical-examination-step/find-by-condition', { isGetParent: true }).then(res => {
                    if (res.data.content && res.data.content.length > 0) {
                        this.parentId = res.data.content[1].medicalExaminationStep.id;
                        this.statusOptions = res.data.content[1].listChildren.map(el => {
                            return {
                                value: el.id,
                                label: el.medicalExaminationStep.name,
                            }
                        })
                        this.statusOptions.unshift({ value: 'null', label: 'Tất cả' })
                    }
                    this.$vs.loading.close();
                    resolve(res)
                }).catch(err => {
                    reject(err);
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        getConsultingData() {
            let payload = {
                endDate: this.dateRange.endDate,  //ngày tạo
                loyaltyCustomerId: this.loyaltyCustomerId,
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                startDate: this.dateRange.startDate,  //ngày tạo
                settingMedicalExaminationStepParentId: this.parentId, //id trạng thái
                settingMedicalExaminationStepId: JSON.parse(this.selectedStatusValue),
                customerType:this.customerType,
                beautyGroupServiceName:this.beautyGroupServiceName ? this.beautyGroupServiceName : null,
                beautyServicePackageName:this.beautyServicePackageName ? this.beautyServicePackageName : null,
                reason:this.reason ? this.reason : null,
                conclude:this.conclude ? this.reason : null
            }
            this.consultingData = [];

            this.$vs.loading();
            this.$crm.post('/beauty-medical-record/find-by-condition', payload).then(res => {
                if (res.data.content && res.data.content.length > 0) {
                    this.consultingData = res.data.content.map(el => {
                        el.stt = this.pageNumber * this.pageSize + res.data.content.indexOf(el) + 1;
                        // el.customerName = el.loyaltyCustomer.fullName;
                        // el.nanoCustomerCode = el.loyaltyCustomer.nanoCustomerCode;
                        // el.phoneNumberCvt = el.loyaltyCustomer.phoneNumber ? this.convertPhone(el.loyaltyCustomer.phoneNumber) : null;
                        // el.birthdayStr = el.loyaltyCustomer.birthday ? moment(el.loyaltyCustomer.birthday).format('DD/MM/YYYY') : el.loyaltyCustomer.birthDayRaw;
                        // el.genderStr = el.loyaltyCustomer.gender === 0 ? this.$t('genderOption.unknown') : el.loyaltyCustomer.gender === 1 ? this.$t('genderOption.male') : el.loyaltyCustomer.gender === 2 ? this.$t('genderOption.female') : null;
                        el.countMedicalReportCompleted = el.countMedicalReportCompleted ? el.countMedicalReportCompleted : 0;
                        el.countMedicalReportNotCompleted = el.countMedicalReportNotCompleted ? el.countMedicalReportNotCompleted : 0;
                        el.dateAdmissionStr = el.dateAdmission ? moment(el.dateAdmission).format('DD/MM/YYYY') : null;
                        el.createdDateCvt = el.createdDate ?  moment(el.createdDate).format('DD/MM/YYYY') : null;
                        return el;
                    })
                }
                this.totalPages = res.data.totalPages;
                this.totalElements = res.data.totalElements;
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        convertPhone(phone) {
            let arrPhone = phone.split('');
            arrPhone[4] = '*';
            arrPhone[5] = '*';
            arrPhone[6] = '*';
            return arrPhone.join().replaceAll(',', '');
        },
    },

    mounted() {
        this.gridApi = this.gridOptions.api;
    },
}
</script>

<style>
.vs--single .vs__selected {
    /* max-width: 160px !important; */
    /* min-width: 150px !important; */
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.table-custom .vs-table--tbody {
    min-height: 300px;
}
</style>
